function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import JsUtility from "../../library/utils/utility";
import EditIcon from "../../library/cms/edit-icon";
import { MediaManagerController } from "../../library/cms/media-manager";
import Console from "../../library/console";

class Video extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onSound", event => {
      var video = this.video;
      video.muted = !video.muted;
      this.icons.mute = null;
      this.icons.sound = 'hide';
      this.mute.classList.remove('hide');
      this.sound.classList.add('hide');
    });

    _defineProperty(this, "onMute", event => {
      var video = this.video;
      video.muted = !video.muted;
      this.icons.mute = 'hide';
      this.icons.sound = null;
      this.mute.classList.add('hide');
      this.sound.classList.remove('hide');
    });

    _defineProperty(this, "onPlay", event => {
      this.playVideo();
    });

    _defineProperty(this, "onPause", event => {
      var video = this.video;
      video.pause();
      this.play.classList.remove('hide');
      this.pause.classList.add('hide');
      this.icons.pause = 'hide';
      this.icons.play = null;
    });

    _defineProperty(this, "playVideo", () => {
      var video = this.video;
      video.play();
      this.play.classList.add('hide');
      this.pause.classList.remove('hide');
      this.icons.pause = null;
      this.icons.play = 'hide';
    });

    this.icons = {
      sound: null,
      mute: 'hide',
      play: 'hide',
      pause: null
    };
  }

  componentDidMount() {
    this.setListener();
    this.playVideo();
  }

  setListener() {
    this.video.addEventListener('ended', () => {
      this.props.onEnd();
    });
  }

  render() {
    var src = this.props.video.url;
    var mIconClass = 'material-icons large-icon';
    var soundIconClass = mIconClass;
    var muteIconClass = mIconClass;
    var playIconClass = mIconClass;
    var pauseIconClass = mIconClass;
    var icons = this.icons;

    if (icons.sound) {
      soundIconClass += ' hide';
    }

    if (icons.mute) {
      muteIconClass += ' hide';
    }

    if (icons.play) {
      playIconClass += ' hide';
    }

    if (icons.pause) {
      pauseIconClass += ' hide';
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, /*#__PURE__*/React.createElement("video", {
      ref: ref => this.video = ref
    }, /*#__PURE__*/React.createElement("source", {
      src: src,
      type: "video/mp4"
    })), /*#__PURE__*/React.createElement("div", {
      className: "component-video-controls"
    }, /*#__PURE__*/React.createElement("span", {
      className: soundIconClass,
      ref: ref => this.sound = ref,
      onClick: this.onSound
    }, "volume_mute"), /*#__PURE__*/React.createElement("span", {
      className: muteIconClass,
      ref: ref => this.mute = ref,
      onClick: this.onMute
    }, "volume_off"), /*#__PURE__*/React.createElement("span", {
      className: playIconClass,
      ref: ref => this.play = ref,
      onClick: this.onPlay
    }, "play_arrow"), /*#__PURE__*/React.createElement("span", {
      className: pauseIconClass,
      ref: ref => this.pause = ref,
      onClick: this.onPause
    }, "pause")));
  }

}

export default class VideoHero extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onEditImagesClick", event => {
      this.mediaController.mode = 'multi-select';
      this.mediaController.show(this.props.item.media);
    });

    _defineProperty(this, "onFilesSelected", files => {
      if (!files || files.length < 1) return;
      var item = this.props.item;
      item.media = files;
      this.props.onChange('item', item);
    });

    _defineProperty(this, "onClick", event => {
      console.log('on click');
      var video = this.media.video;

      if (video && video.url) {
        this.showVideo = true;
        this.forceUpdate();
      }
    });

    _defineProperty(this, "onEnd", () => {
      this.showVideo = false;
      this.forceUpdate();
    });

    this.showVideo = false;
  }

  componentDidMount() {}

  get media() {
    var obj = {
      image: null,
      video: null
    };
    var media = this.props.item.media;
    media.forEach(ele => {
      if (ele.meta === 'Hero') {
        obj.image = ele;
      } else if (ele.meta === 'Video') {
        obj.video = ele;
      }
    });
    return obj;
  }

  getImageCss(video) {
    return video ? 'pointer' : 'no-pointer';
  }

  render() {
    var image = this.media.image;
    var video = this.media.video;
    var src = image.url;
    var mobileSrc = JsUtility.toMobileUrl(src);
    var alt = image.title;
    var showVideo = false;
    var imageCss = this.getImageCss(video);
    var showImage = true;
    showVideo = this.showVideo;
    if (showVideo) showImage = false;
    var active = this.props.active;

    if (active) {
      this.showVideo = false;
      showVideo = false;
      showImage = true;
    }

    var src = src += '?width=2200';
    Console.write(src);
    return /*#__PURE__*/React.createElement("div", {
      className: "image-stretch-container"
    }, showImage && /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 641px)",
      srcSet: src
    }), /*#__PURE__*/React.createElement("source", {
      media: "(max-width: 640px)",
      srcSet: mobileSrc
    }), alt ? /*#__PURE__*/React.createElement("img", {
      src: src,
      alt: alt,
      className: imageCss,
      onClick: this.onClick
    }) : /*#__PURE__*/React.createElement("img", {
      src: src,
      className: imageCss,
      onClick: this.onClick
    })), showVideo && /*#__PURE__*/React.createElement(Video, {
      video: video,
      onEnd: this.onEnd
    }), active && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EditIcon, {
      active: true,
      cls: "translucent-icon-top",
      onClick: this.onEditImagesClick
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: "/api/MediaFile",
      data: this.props.media,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.onFilesSelected
    }))));
  }

}